export function createWS(path) {
  const token = localStorage.getItem("access_token");

  if (!token || token === "null" || token === "undefined") {
    return null;
  }

  const baseUrl =
    process.env.REACT_APP_WS_URL ||
    `${window.location.protocol === "https:" ? "wss:" : "ws:"}//${window.location.host}`;

  const cleanPath = path.startsWith("/") ? path.slice(1) : path;

  const url = `${baseUrl}/${cleanPath}?token=${token}`;

  return new WebSocket(url);
}
